module.exports = __webpack_public_path__ + "img/info-detail.9ea1f2ae.svg";